import { QRCode, Success } from "@indietabletop/appkit";
import { href } from "../App/href";
import { Page, ViewContent } from "../oss/Layout/Layout";
import { qr, text } from "./style.css";

export function ShareAppPage() {
  return (
    <Page title="Share" backHref={href("~/")}>
      <ViewContent isCentered>
        <div>
          <QRCode
            className={qr}
            url={new Success("https://greathelm.indietabletop.club")}
          />

          <p className={text}>
            <em>Scan the code to open the Greathelm App</em>
          </p>
        </div>
      </ViewContent>
    </Page>
  );
}
